import { NavigationItem } from './types'
import { routes } from 'utils/routes'
import { Language } from 'types/language'

/**
 * Returns the navigation items for the page header
 *
 * @param {Language} locale
 * @returns {NavigationItem[]}
 */
export const getNavigationItems = (locale: Language): NavigationItem[] => {
  return [
    {
      key: 'producers',
      route: routes(locale).producers
    },
    {
      key: 'pricing',
      children: [
        {
          key: 'pricing.consumption',
          route: routes(locale).pricing
        },
        {
          key: 'pricing.injection',
          route: routes(locale).injectionTariff
        },
        {
          key: 'pricing.boltXPlenty',
          route: routes(locale).boltXPlenty
        }
      ]
    },
    {
      key: 'move',
      route: routes(locale).move
    },
    {
      key: 'b2b',
      route: routes(locale).becomeProducer
    },
    {
      key: 'news',
      route: routes(locale).blog
    },
    {
      key: 'more',
      children: [
        {
          key: 'more.about',
          route: routes(locale).about
        },
        ...(locale === Language.DUTCH
          ? [
              {
                key: 'more.encyclopedia',
                route: routes(locale).encyclopedia
              }
            ]
          : []),
        {
          key: 'more.faq',
          route: routes(locale).faq
        },
        {
          key: 'more.referral',
          route: routes(locale).referral
        }
      ]
    }
  ]
}
